import styled from 'styled-components';

export const UploadMerchantDocumentWrapper = styled.div`
  .hide {
    display: none;
  }

  button {
    height: 4rem;
    min-height: 38px;
    padding: 0 1.7rem;
    max-width: fit-content;
    text-transform: none;
  }

  .import-document {
    display: flex;
    align-items: center;
    gap: 3rem;

    > div {
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    a {
      display: flex;
      align-items: center;
      width: 100%;
      flex: 1;
    }

    .upload-document.disabled {
      cursor: not-allowed;
      background-color: #ffbbbe;
    }

    .delete-document.disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  td {
    padding: 1.6rem 4.6rem;
    font-weight: 300;
    font-size: 1.6rem;
    border-bottom: 1px solid #c8cbd0;
    max-width: 50%;

    &:not(:first-child) {
      padding-left: 1.8rem;
    }
  }

  .submit-icon {
    margin-left: 1rem;
    font-size: 1.3rem;
  }
`;

export const Banner = styled.div`
  background-color: #7db4c4;
  border-radius: 0 0 90px 0;
`;

export const FooterNote = styled(Banner)`
  display: flex;
  flex-direction: row;
  padding: 3rem;
  justify-content: center;
  border-radius: 90px 0 90px 0;
  margin: 7rem 15rem 5rem 15rem;

  p {
    text-align: center;
    line-height: 1.5;
    flex: 1;
  }

  .bold {
    font-weight: bold;
  }
`;
